import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
    const testimonialsSwiper = new Swiper('.testimonials-section-slider', {
        modules: [Navigation, Pagination, A11y],
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.arrow-next-testimonials',
            prevEl: '.arrow-prev-testimonials',
        },
        a11y: true,
        keyboardControl: true,
        grabCursor: true,
        slidesPerView: 1,
        loop: true,
        spaceBetween: 40,
        slidesPerView: 1,
        spaceBetween: 40,
        autoHeight: true,
    });

    //  listen for browser size changes
    window.onresize = function() {
        testimonialsSwiper.update();
    };
};